<template>
  <management-page :pageName="pageName" :menu="menu" class="management" />
</template>

<script>
import ManagementPage from "@/components/Management/Management";
import { managementViewMixin } from "@/mixins/management/managementViewMixin";
import Support from "@/assets/management/support.svg";
import Info from "@/assets/management/info.svg";
import PlayArrow from "@/assets/management/play_arrow.svg";

export default {
  name: "Support",

  components: { ManagementPage },

  mixins: [managementViewMixin],

  computed: {
    /**
     * Determine the page title
     * @returns {VueI18n.TranslateResult}
     */
    pageName() {
      return this.$i18n.t("Support");
    },

    /**
     * Determines the menu available in the sidebar on the page
     * @returns {[{submenu: [{route: string, dev: boolean, name: string, disabled: boolean}], name: VueI18n.TranslateResult, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: string, disabled: boolean}], name: VueI18n.TranslateResult, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: string, disabled: boolean}], name: string, icon, disabled: boolean}]}
     */
    menu() {
      return [
        {
          name: this.$i18n.t("TechnicalSupport"),
          icon: Support,
          disabled: false,
          submenu: [
            {
              name: this.$i18n.tc("Ticket", 2),
              route: "tickets",
              disabled: !this.userHasManagementPermission(
                "third_party_apis_youtrack_issues_list"
              ),
              dev: false
            }
          ]
        },
        {
          name: this.$i18n.t("Start"),
          icon: PlayArrow,
          disabled: !this.isSuperAdmin,
          submenu: [
            {
              name: this.$i18n.tc("Reference", 2),
              route: "references",
              disabled: false, // alterar para as permissões corretas
              dev: true
            }
          ]
        }
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Support.vue